<template>
    <div class="product-list">
        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                {{$t('product.product')}}
                <v-spacer></v-spacer>
                <v-text-field dark v-model="search" append-icon="search" v-bind:label="$t('product.search')" single-line hide-details></v-text-field>
                <v-btn dark icon :to="{name: 'product-detail'}"><v-icon>add</v-icon></v-btn>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="loadAll"
                    class="elevation-1"
                    :pagination.sync="pagination"
                    :search="search"
            >
                <template slot="headerCell" slot-scope="props">
                    {{$t(props.header.text)}}
                </template>
                <template v-slot:items="props">
                    <td>{{ props.item.attributes.title }}</td>
                    <td>{{ props.item.attributes.number }}</td>
                    <td>{{ props.item.attributes.customer_number }}</td>
                    <td>{{ props.item.attributes.description }}</td>
                    <td>{{ props.item.attributes.extra_description }}</td>
                    <td class="text-sm-right">
                        <v-btn icon :to="{ name: 'product-detail', params: { id: props.item.id }}"><v-icon color="primary">edit</v-icon></v-btn>
                        <v-btn icon @click="deletePost(props.item);"><v-icon color="primary">delete</v-icon></v-btn>
                    </td>
                </template>
                <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>

    </div>
</template>

<script  >
    import {Component, Vue} from 'vue-property-decorator';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            this.loadAllPosts();
        },
        methods: {
            ...mapActions({
                loadAllPosts: 'products/loadAll',
                deletePost: 'products/delete',
            }),
        },
        computed: {
            ...mapGetters({
                loading: "products/isLoading",
                error: "products/isError",
                loadAll: "products/all",
            }),
        },
        data() {
            return {
                search: "",
                headers: [
                    {text: 'product.title', align: 'left', value: 'attributes.title'},
                    {text: 'product.number', align: 'left', value: 'attributes.number'},
                    {text: 'product.customer_number', value: 'attributes.customer_number'},
                    {text: 'product.description', value: 'attributes.description'},
                    {text: 'product.extra_description', value: 'attributes.extra_description'},
                    {text: '', value: 'actions'},
                ],
                pagination: {
                    rowsPerPage: 10,
                },
            };
        },
    };
</script>
